import React, { useEffect, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { animateScroll as scroll } from 'react-scroll'
import { useTranslation } from 'react-i18next'
import { Close, Menu } from '@material-ui/icons'
import {
  AppBar,
  Box,
  Link,
  Toolbar,
  Typography,
  Divider,
  Slide,
  useScrollTrigger
} from '@material-ui/core'
import Logo from 'src/assets/images/ufc/logo-lsbd-small.svg'
import Sidebar from 'src/components/Mobile/Sidebar/Sidebar'
import { Language } from 'src/types/global'
import { useStyles } from './NavbarMobile.styles'

const NavbarMobile = ({ isOpen, toggle }: any) => {
  const { i18n } = useTranslation()

  const [languageOption, setLanguageOption] = useState<string>('pt')

  useEffect(() => {
    setLanguageOption(i18n.language)
  }, [i18n.language])

  const handleChangeLanguage = (lang: string) => {
    setLanguageOption(lang)
    i18n.changeLanguage(lang).then()
  }

  const toggleHome = () => {
    scroll.scrollToTop()
  }
  const classes = useStyles()
  const trigger = useScrollTrigger()

  const getOptionClass = (lang: Language) =>
    `${classes.option} ${languageOption === lang ? classes.activeOption : ''}`

  return (
    <>
      <Slide appear={false} direction="down" in={!trigger || isOpen}>
        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar className={classes.toolBar}>
            <Link
              component={RouterLink}
              onClick={toggleHome}
              to="/"
              underline="none"
            >
              <img src={Logo} alt="logo lsbd" />
            </Link>
            <Box className={classes.box}>
              <Box className={classes.boxOptionsLanguage}>
                <Typography
                  className={getOptionClass('pt')}
                  onClick={() => handleChangeLanguage('pt')}
                  variant="body1"
                >
                  PT
                </Typography>
                <Divider orientation="vertical" className={classes.divider} />
                <Typography
                  className={getOptionClass('en')}
                  onClick={() => handleChangeLanguage('en')}
                  variant="body1"
                >
                  EN
                </Typography>
              </Box>
              {isOpen ? (
                <Close fontSize="large" onClick={toggle} />
              ) : (
                <Menu fontSize="large" onClick={toggle} />
              )}
            </Box>
          </Toolbar>
        </AppBar>
      </Slide>
      <Toolbar />
      <Sidebar isOpen={isOpen} toggleSidebar={toggle} />
    </>
  )
}

export default NavbarMobile
